import React from 'react';
import { useSelector } from 'react-redux';
import FullscreenIcon from './FullscreenIcon';
import MinimizeIcon from './MinimizeIcon';
import { usePlayer } from '../../../PlayerContext';

function Fullscreen() {
  const player = usePlayer();
  const isFullscreen = useSelector(state => state.playback.isFullscreen);

  const toggleFullScreen = () => player.toggleFullScreen();

  if (isFullscreen) {
    return (
      <MinimizeIcon onClick={toggleFullScreen} />
    );
  }

  return (
    <FullscreenIcon onClick={toggleFullScreen} />
  );
}

export default React.memo(Fullscreen);
